import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Colors } from 'styles/variables/colors';

const { consultationButton, white, black } = Colors;

export const NextButton = styled.button`
    width: 7em;
    margin-left: auto;
    margin-right: 1rem;
    height: 45px;
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    line-height: 0.9;
    gap: 10px;
    padding: 18px 24px !important;
    background: ${consultationButton};
    border-radius: 10px;
    ${TextStyle({ fontSize: '25px', fontWeight: '500', color: white })};
    font-style: normal;
    text-transform: capitalize;
    cursor: pointer;
    border: 2px solid rgba(117, 42, 255, 0.5);
    :hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
    }

    @media screen and (max-width: 500px) {
        width: 5em;
    }
`;

export const BackButton = styled.button`
    width: 5.5em;
    margin-left: 1rem;
    height: 45px;
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    line-height: 0.9;
    gap: 10px;
    padding: 18px 24px !important;
    background: ${white};
    border-radius: 10px;
    ${TextStyle({ fontSize: '25px', fontWeight: '500', color: black })};
    font-style: normal;
    text-transform: capitalize;
    cursor: pointer;
    border: 2px solid rgba(117, 42, 255, 0.5);
    :hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
    }
    @media screen and (max-width: 500px) {
        width: 4em;
    }
`;

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    @media screen and (max-width: 800px) {
        gap: 15px 10px;
    }
`;

export const GridItem = styled.div`
    padding: 16px;
    @media screen and (max-width: 800px) {
        padding: 0px;
    }
`;

type Props = {
    isActive?: boolean;
};

export const Explanation = styled.span<Props>`
    cursor: pointer;
`;

export const Container = styled.div`
    border: 1px solid #8353e2ff;
    border-radius: 4px;
    gap: 0.4rem;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    border-top: 1px solid lightgray;
`;

// export const Title = styled.div<titleProps>`
//     padding: 1rem;
//     border-bottom: 1px solid lightgray;

//     max-height: 320px;
//     overflow-y: auto;
// `;

// export const CrossSimpleIcon = styled(CrossSimpleIconComponent)`
//     fill: ${Colors.darkGray};
// `;

// export const FullExplanation = styled.div`
//     ${TextStyle({
//         fontSize: '16px',
//         fontWeight: '400',
//         color: Colors.darkGray,
//         fontFamily: Variables.assistant,
//     })};
//     line-height: 1.2;
//     overflow-y: auto;
//     max-height: 180px;
//     width: 100%;
//     padding: 0rem 1rem 0.5rem 1rem;
// `;
